import { ApiFailure } from "./api";

/**
 * Mensagens em pt-BR para os erros da API que as telas tratam de forma genérica (limites e regras das Tasks 8–9).
 * Códigos fora da lista mantêm a mensagem da API, que já vem em pt-BR (ex.: duplicate_document).
 */
const MESSAGES: Record<string, string> = {
  job_in_progress:
    "Você já tem uma exportação em andamento. Acompanhe em Ações assíncronas, no topo da página.",
  payload_too_large:
    "Os dados enviados são grandes demais. Reduza observações ou campos customizados e tente de novo.",
  rate_limited: "Muitas tentativas em pouco tempo. Aguarde um minuto e tente de novo.",
  cnpj_rejected: "A Receita não reconheceu este CNPJ. Confira o número ou preencha os dados à mão.",
  invalid_seller: "Vendedor inválido: escolha um vendedor ativo desta empresa.",
  limit_reached: "Limite de cadastros desta empresa atingido.",
  lookup_unavailable: "A consulta está indisponível no momento. Preencha os dados à mão.",
  quote_converted: "Esta proposta já foi convertida em pedido e não pode mais ser alterada.",
  status_changed: "A situação mudou enquanto você olhava. A tela foi atualizada; confira e tente de novo.",
  module_unavailable: "A conversão em pedido fica disponível com o módulo de pedidos de venda.",
  too_many_orders: "Selecione no máximo 50 pedidos por vez.",
  pdf_too_large: "O PDF ficaria grande demais. Imprima menos pedidos por vez.",
  future_date: "A data não pode ser futura.",
  balance_limit: "O saldo da conta passaria do limite permitido.",
  active_charge_exists: "Esta conta já tem um Pix aguardando pagamento. Cancele-o antes de gerar outro.",
  provider_unavailable: "O provedor Pix está indisponível no momento. Tente de novo em instantes.",
  charge_paid: "Este Pix já foi pago; a baixa acontece automaticamente.",
  active_charges:
    "Há cobranças Pix aguardando pagamento no provedor atual. Cancele-as (ou espere vencerem) antes de trocar.",
  unregistered_item_forbidden: "Seu cadastro de vendedor não permite incluir itens não cadastrados.",
};

export function errorMessage(e: unknown): string {
  if (e instanceof ApiFailure) return MESSAGES[e.code] ?? e.message;
  return e instanceof Error ? e.message : "Não foi possível concluir. Tente de novo.";
}
